<template>
    <div>
        <TotemFilterResult :listLength="filteredCount" />
        <HideFilters v-on:toggleFilters="toggleShowMoreFilters" :filtersHidden="!showMoreFilters"/>
        <Sorter/>
        <CourseListViewToggle v-if="!canShowListToggleView" />
    </div>
</template>

<script>
    import CourseListViewToggle from 'components/user/items-listings/courselist/CourseListViewToggle'
    import Sorter from 'components/searchable-listing/filters-elements/fields/Sorter'
    import { mapGetters } from 'vuex'
    import HideFilters from 'components/user/shared/HideFilters.vue'

    export default {
        name: 'ResultsAndSorter',
        components: { Sorter, CourseListViewToggle, HideFilters },
        props: {
            canShowListToggleView: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            ...mapGetters({
                filteredCount: 'Search/filteredCount',
                showMoreFilters: 'CourseFilter/getShowMoreFilterState'

            })
        },
        methods: {
            toggleShowMoreFilters () {
                this.$store.dispatch('CourseFilter/showMoreFilters', !this.showMoreFilters)
            }
        }
    }
</script>

